import React from 'react';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
//import DollarIcon from 'material-ui/svg-icons/editor/attach-money';
import CustomerIcon from 'material-ui/svg-icons/social/person';
import { translate } from 'admin-on-rest';

const styles = {
    card: { borderLeft: 'solid 4px #fd9512', flex: '1', marginRight: '1em' },
    icon: { float: 'right', width: 50, height: 50, padding: 16, color: '#fd9512' },
	h3: { marginTop: '0' },
	label: {fontWeight:'bold', marginRight: '0.5em', display:'block', marginBottom:'0.5em', marginTop: '0.5em'}
};

export default translate(({ userdetails, translate }) => (
    <Card style={styles.card}>
        <CustomerIcon style={styles.icon} />
        <CardTitle title={`Welkom, ${userdetails.company_name}`} />
		 <CardText>
				<label style={styles.label}>Bedrijfsnaam: </label> {userdetails.company_name}
				<br/><br/>
				<label style={styles.label}>Website: </label> {userdetails.company_site}
				<br/><br/>
				<label style={styles.label}>E-mail: </label> {userdetails.email}
				<br/><br/><br/>
				<RaisedButton label="Wijzig gegevens" href={`#/userauth/details/${userdetails.company_name}`} primary={true} />
				
		</CardText>
    </Card>
));





// WEBPACK FOOTER //
// ./src/dashboard/UserDetails.js